import PropTypes from 'prop-types'
import Tooltip from '../../common/tooltip'
import { formatEmptyValue } from '../../../utils/common'
import { Edit, Trash } from '@styled-icons/boxicons-solid'

const DeviceConnectionsRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-1 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-3/12 items-center table_text">
          <Tooltip message={props?.device_data?.name}>
            <div>{formatEmptyValue(props?.device_data?.name)}</div>
          </Tooltip>
        </div>
        <div className="flex w-4/12 pl-6 items-center table_text">
          <Tooltip message={props?.signal_obj?.label}>
            <div>{formatEmptyValue(props?.signal_obj?.label)}</div>
          </Tooltip>
        </div>
        <div className="w-2/12 pl-6 items-center table_text">
          <Tooltip message={props?.pin_from}>
            <div>{props?.pin_from}</div>
          </Tooltip>
        </div>
        <div className="w-2/12 pl-6 items-center table_text">
          <Tooltip message={props?.pin_to}>
            <div>{props?.pin_to}</div>
          </Tooltip>
        </div>
        <div className="flex w-1/12 pl-6 items-center justify-end">
          <span
            onClick={() => {
              props.onShowDetails()
            }}
            className="cursor-pointer px-1"
          >
            <Edit size="2rem" color="#0189E9" />
          </span>
          <span
            onClick={() => {
              props.onDelete()
            }}
            className="cursor-pointer px-1"
          >
            <Trash size="2rem" color="#0189E9" />
          </span>
        </div>
      </div>
    </div>
  )
}

DeviceConnectionsRow.propTypes = {
  onShowDetails: PropTypes.func,
  onDelete: PropTypes.func,
}

export default DeviceConnectionsRow
